module.exports = __webpack_public_path__ + "img/non-manufacturing.870b22f8.jpg";